"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _ablyHubspotJs = _interopRequireDefault(require("ably-hubspot-js"));

var _constants = require("composer-lib/lib/constants");

var BASE_URI = 'composition/v1/pubsub';

var getAblyTokenRequestCallback = function getAblyTokenRequestCallback(compositionId) {
  return function (params, callback) {
    return _apiClient.default.get(BASE_URI + "/" + compositionId).then(function (tokenRequest) {
      callback(null, tokenRequest);
    });
  };
};

var createActionCallerFromMethods = function createActionCallerFromMethods(_ref) {
  var _typeToMethod;

  var handleCreate = _ref.handleCreate,
      handleDelete = _ref.handleDelete,
      handleUpdate = _ref.handleUpdate;
  var typeToMethod = (_typeToMethod = {}, (0, _defineProperty2.default)(_typeToMethod, _constants.MethodTypes.CREATE, handleCreate), (0, _defineProperty2.default)(_typeToMethod, _constants.MethodTypes.DELETE, handleDelete), (0, _defineProperty2.default)(_typeToMethod, _constants.MethodTypes.UPDATE, handleUpdate), _typeToMethod);
  return function (msg) {
    return typeToMethod[msg.method] && typeToMethod[msg.method](msg);
  };
};

var createUpdateHandler = function createUpdateHandler(actions, userId) {
  var addCommentFromUpdate = actions.addCommentFromUpdate,
      addConversationFromUpdate = actions.addConversationFromUpdate,
      deleteCommentFromUpdate = actions.deleteCommentFromUpdate,
      deleteConversationFromUpdate = actions.deleteConversationFromUpdate,
      lockRequestFromUpdate = actions.lockRequestFromUpdate,
      lockRequestRejectedFromUpdate = actions.lockRequestRejectedFromUpdate,
      updateCompositionFromUpdate = actions.updateCompositionFromUpdate,
      updateLockFromUpdate = actions.updateLockFromUpdate;
  var CONVERSATION = _constants.RealtimeTargetTypes.CONVERSATION,
      COMMENT = _constants.RealtimeTargetTypes.COMMENT,
      COMPOSITION = _constants.RealtimeTargetTypes.COMPOSITION,
      LOCK = _constants.RealtimeTargetTypes.LOCK,
      LOCK_REQUEST = _constants.RealtimeTargetTypes.LOCK_REQUEST,
      LOCK_REQUEST_REJECTION = _constants.RealtimeTargetTypes.LOCK_REQUEST_REJECTION;
  return function (message) {
    var data = message.data;

    if (typeof data === 'string') {
      data = JSON.parse(data);
    }

    switch (data.target.type) {
      case COMMENT:
        return createActionCallerFromMethods({
          handleCreate: function handleCreate(msg) {
            if (msg.payload.authorId !== userId) {
              addCommentFromUpdate(msg.payload);
            }
          },
          handleDelete: function handleDelete(msg) {
            deleteCommentFromUpdate(msg.payload);
          }
        })(data);

      case COMPOSITION:
        return createActionCallerFromMethods({
          handleUpdate: function handleUpdate(msg) {
            updateCompositionFromUpdate(msg, userId);
          }
        })(data);

      case CONVERSATION:
        return createActionCallerFromMethods({
          handleCreate: function handleCreate(msg) {
            addConversationFromUpdate(msg.payload);
          },
          handleDelete: function handleDelete(msg) {
            deleteConversationFromUpdate(msg.payload);
          }
        })(data);

      case LOCK:
        return createActionCallerFromMethods({
          handleUpdate: function handleUpdate(msg) {
            updateLockFromUpdate({
              data: msg,
              userId: userId
            });
          }
        })(data);

      case LOCK_REQUEST:
        return createActionCallerFromMethods({
          handleCreate: function handleCreate(msg) {
            lockRequestFromUpdate(msg.payload);
          }
        })(data);

      case LOCK_REQUEST_REJECTION:
        return createActionCallerFromMethods({
          handleCreate: function handleCreate(msg) {
            lockRequestRejectedFromUpdate({
              data: msg,
              userId: userId
            });
          }
        })(data);

      default:
        return undefined;
    }
  };
};

var getChannel = function getChannel(client) {
  // set up listeners via channel.subscribe
  var channelName = Object.keys(JSON.parse(client.auth.tokenDetails.capability))[0];
  var channel = client.channels.get(channelName);
  return channel;
};

function setupPresence(channel) {
  var _this = this;

  channel.presence.subscribe(_constants.RealtimePresenceTypes.PRESENT, function (member) {
    _this.addUserToComposition({
      member: member,
      currentUser: _this.userId
    });
  });
  channel.presence.subscribe(_constants.RealtimePresenceTypes.ENTER, function (member) {
    _this.addUserToComposition({
      member: member,
      currentUser: _this.userId
    });
  });
  channel.presence.subscribe(_constants.RealtimePresenceTypes.LEAVE, function (member) {
    _this.removeUserFromComposition({
      member: member
    });
  });
  channel.presence.enter();
}

function setupMessageListener(channel) {
  this.messageListener = createUpdateHandler({
    addCommentFromUpdate: this.addCommentFromUpdate,
    addConversationFromUpdate: this.addConversationFromUpdate,
    addUserToComposition: this.addUserToComposition,
    deleteCommentFromUpdate: this.deleteCommentFromUpdate,
    deleteConversationFromUpdate: this.deleteConversationFromUpdate,
    lockRequestFromUpdate: this.lockRequestFromUpdate,
    lockRequestRejectedFromUpdate: this.lockRequestRejectedFromUpdate,
    removeUserFromComposition: this.removeUserFromComposition,
    updateCompositionFromUpdate: this.updateCompositionFromUpdate,
    updateLockFromUpdate: this.updateLockFromUpdate
  }, this.userId);
  channel.subscribe(this.messageListener);
}

var createRequestLock = function createRequestLock(channel) {
  return function (userId) {
    var message = {
      method: _constants.MethodTypes.CREATE,
      payload: userId,
      target: {
        type: _constants.RealtimeTargetTypes.LOCK_REQUEST
      }
    };
    return new Promise(function (resolve) {
      channel.publish('composition message', message, function () {
        resolve();
      });
    });
  };
};

var createRejectRequestLock = function createRejectRequestLock(channel) {
  return function (userId) {
    var message = {
      method: _constants.MethodTypes.CREATE,
      payload: userId,
      target: {
        type: _constants.RealtimeTargetTypes.LOCK_REQUEST_REJECTION
      }
    };
    return new Promise(function (resolve) {
      channel.publish('composition message', message, function () {
        resolve();
      });
    });
  };
};

var _default = {
  init: function init(_ref2) {
    var _this2 = this;

    var addCommentFromUpdate = _ref2.addCommentFromUpdate,
        addConversationFromUpdate = _ref2.addConversationFromUpdate,
        addUserToComposition = _ref2.addUserToComposition,
        compositionId = _ref2.compositionId,
        deleteCommentFromUpdate = _ref2.deleteCommentFromUpdate,
        deleteConversationFromUpdate = _ref2.deleteConversationFromUpdate,
        lockRequestFromUpdate = _ref2.lockRequestFromUpdate,
        lockRequestRejectedFromUpdate = _ref2.lockRequestRejectedFromUpdate,
        removeUserFromComposition = _ref2.removeUserFromComposition,
        updateCompositionFromUpdate = _ref2.updateCompositionFromUpdate,
        updateLockFromUpdate = _ref2.updateLockFromUpdate,
        userId = _ref2.userId;

    if (this.ably) {
      throw new Error('Cannot init Ably when an instance already exists');
    }

    this.addCommentFromUpdate = addCommentFromUpdate;
    this.addConversationFromUpdate = addConversationFromUpdate;
    this.addUserToComposition = addUserToComposition;
    this.compositionId = compositionId;
    this.deleteCommentFromUpdate = deleteCommentFromUpdate;
    this.deleteConversationFromUpdate = deleteConversationFromUpdate;
    this.lockRequestFromUpdate = lockRequestFromUpdate;
    this.lockRequestRejectedFromUpdate = lockRequestRejectedFromUpdate;
    this.removeUserFromComposition = removeUserFromComposition;
    this.updateCompositionFromUpdate = updateCompositionFromUpdate;
    this.updateLockFromUpdate = updateLockFromUpdate;
    this.userId = userId;
    this.client = new _ablyHubspotJs.default.Realtime({
      authCallback: getAblyTokenRequestCallback(compositionId),
      useTokenAuth: true
    });
    this.client.connection.on('connected', function () {
      try {
        _this2.channel = getChannel(_this2.client);
        setupPresence.bind(_this2)(_this2.channel);
        setupMessageListener.bind(_this2)(_this2.channel);
        _this2.client = _this2;
        _this2.requestLock = createRequestLock(_this2.channel);
        _this2.rejectRequestLock = createRejectRequestLock(_this2.channel);
      } catch (e) {
        throw new Error("Ably connection handling failed with error \"" + e + "\"");
      }
    });

    this.unsubscribeAll = function () {
      _this2.channel.unsubscribe(_this2.messageListener);
    };
  }
};
exports.default = _default;
module.exports = exports.default;